import {IAlert} from '../../../../actions/proto';
import {BusinessRuleAction} from '../../../../constants';
import {
    BusinessRuleOpenTask,
    BusinessRuleSendMailEmails,
    BusinessRuleSendMailSendText,
    BusinessRuleSendMailUsers,
    BusinessRuleSendNoti,
    BusinessRuleVerification,
    BusinessRulewebHook
} from '../../../RulesListDialog/consts';
import {priority} from '@priority-software/priority-proto-api/lib';
import {AutomationChoose} from '../../../../reducer/model';
import {imageHTMLProcess} from '../../../../../EmailEditor/utils/imageHTMLProcess';
import {TAlertMessage} from '../../../../types';

export const prepareChatboxData = (
    alert: priority.netitems.form.IAlert,
    options: AutomationChoose[],
    isStatusActions: boolean
) => {
    return isStatusActions && !alert.BPM?.TimeValue && !alert.BPM?.TimeField
        ? options.map(item => {
              return item.value === BusinessRuleAction.ChangeStatusTo
                  ? {...item, disabled: true}
                  : item;
          })
        : options;
};

export const getMonitorMessage = (data: IAlert) => {
    switch (data.MessageType) {
        case BusinessRuleAction.EmailMsg:
            if (data.RecipientMail.length > 0) {
                return BusinessRuleSendMailEmails;
            } else if (data.RecipientUser.length > 0) {
                return BusinessRuleSendMailUsers;
            }
            return null;
        case BusinessRuleAction.TextMsg:
            return BusinessRuleSendMailSendText;
        case BusinessRuleAction.OpenTask:
            return BusinessRuleOpenTask;
        case BusinessRuleAction.PushNotification:
            return BusinessRuleSendNoti;
        case BusinessRuleAction.Webhook:
            return BusinessRulewebHook;
        case BusinessRuleAction.UserVerification:
            return BusinessRuleVerification;
        default:
            return null;
    }
};

export const checkingNewEmailTemplateSize = async (CoverLetters: TAlertMessage[]) => {
    return new Promise<{isContinue: boolean; CoverLetters: TAlertMessage[]}>(async resolve => {
        if (CoverLetters.length > 0) {
            for (const template of CoverLetters) {
                const Message = template?.Message;

                if (Message) {
                    const {html, isOverSize} = await imageHTMLProcess(Message);

                    template.Message = html;

                    if (isOverSize) {
                        return resolve({isContinue: false, CoverLetters});
                    }
                }
            }
        }

        return resolve({isContinue: true, CoverLetters});
    });
};
